import { client } from "../client";

/**
 * Reorders the character-select LIST alphabetically by character name, like
 * AO2-Client. The icon grid is left in server/ID order; only the left list is
 * sorted. Called once the character list has finished loading.
 */
export const sortCharList = () => {
  const list = document.getElementById("client_charlist");
  if (!list) return;

  const indices = client.chars
    .map((_: any, i: number) => i)
    .filter((i: number) => document.getElementById(`charlist_${i}`));

  indices.sort((a: number, b: number) =>
    (client.chars[a]?.name || "").localeCompare(
      client.chars[b]?.name || "",
      undefined,
      { sensitivity: "base" },
    ),
  );

  // Re-append in sorted order (appendChild moves the existing node).
  for (const i of indices) {
    const entry = document.getElementById(`charlist_${i}`);
    if (entry) list.appendChild(entry);
  }
};
